import { useMemo } from 'react'

import type { DropdownOption } from '#formFields/types'
import { useShowProfileQuery } from '#profile/api'
import { Ownership } from '#profile/schemas'

export type UseOwnershipOptionsResult = {
  isLoading: boolean
  options: DropdownOption[]
}

export const useOwnershipOptions = ({
  showJoint,
}: {
  showJoint?: boolean
}): UseOwnershipOptionsResult => {
  const { isLoading, data: profileDoc } = useShowProfileQuery('default')

  const options = useMemo(() => {
    if (!profileDoc) {
      return []
    }

    const opts: DropdownOption[] = [
      {
        value: Ownership.Person,
        label: profileDoc.entity.members.person.name || 'You',
      },
    ]

    if (profileDoc.entity.members.partner) {
      opts.push({
        value: Ownership.Partner,
        label: profileDoc.entity.members.partner.name || 'Partner',
      })
    }

    if (showJoint && profileDoc.entity.members.partner) {
      opts.push({
        value: Ownership.Joint,
        label: 'Joint',
      })
    }

    return opts
  }, [profileDoc, showJoint])

  return { isLoading, options }
}
